import beautyBox from "../img/compozitii-cutie/beauty-box.webp";
import gipsophylaBox from "../img/compozitii-cutie/gipsophyla-box.webp";
// import blueBox from "../img/compozitii-cutie/blue-box.webp";
// import greyBox from "../img/compozitii-cutie/grey-box.webp";
import eustomaXl from "../img/compozitii-cutie/esutoma-xl.webp";
import eustomaWhite from "../img/compozitii-cutie/eustoma-white.webp";
import aestheticBox from "../img/compozitii-cutie/aesthetic-box.webp";
// import eleganceBox from "../img/compozitii-cutie/elegance-box.webp";
// import summer from "../img/compozitii-cutie/summer.webp";
// import timelessBeauty from "../img/compozitii-cutie/timeless-beauty-box.webp";
import radiantPiony from "../img/compozitii-cutie/radiant-piony-box.webp";
import elegantBloom from "../img/compozitii-cutie/elegant-bloom.webp";
import floralSymphony from "../img/compozitii-cutie/floral-symphony.webp";
import pinkHydrangea from "../img/compozitii-cutie/pink-hydrangea-box.webp";
import orchidBox from "../img/compozitii-cutie/orchid-box.webp";
// import blueHydrangea from "../img/compozitii-cutie/blue-hydrangia-box.webp";
//250-299
const compozitiiCutie = [
  {
    id: 260,
    name: "Radiant Peony Box",
    price: "3500 lei",
    description:
      "Cutie cu aspect luxuriant diamnetru 19cm formata din trandafiri de tip bujor, bujori roz, fresie alba, azothamus, hypericum si eucalipt.",
    images: [radiantPiony],
  },
  // {
  //   id: 252,
  //   name: "Blue Box",
  //   price: "1200 lei",
  //   description:
  //     "Compoziție în cutie diametru 20 cm formată din hortensie, eustome, trandafiri crenguța și crizantema.",
  //   images: [blueBox],
  //   // checkAvailability: true,
  // },
  {
    id: 251,
    name: "Gipsophyla Box",
    price: "600 lei",
    description:
      "Compoziție în cutie de diametrul 16 cm formată din gipsofila albă. ",
    images: [gipsophylaBox],
  },

  // {
  //   id: 253,
  //   name: "Grey Box",
  //   price: "1200 lei",
  //   description:
  //     "Compoziție în cutie cu diametru 20 cm formată din hortensie, eustome, crizanteme, trandafiri crenguța si  eucalipt.",
  //   images: [greyBox],
  //   // checkAvailability: true,
  // },
  {
    id: 254,
    name: "Eustoma XL",
    price: "4000 lei",
    description:
      "Coș de mărime XL format din eustome, trandafiri si hypericum.",
    images: [eustomaXl],
  },
  {
    id: 255,
    name: "Eustoma White",
    price: "3200 lei",
    description: "Coș de mărime XL format din eustome si anthirinium.",
    images: [eustomaWhite],
  },
  {
    id: 256,
    name: "Aesthetic Box",
    price: "1900 lei",
    description:
      "Compoziție în cutie diametrul 20 cm formată din trandafiri crenguța, eustome, dianthus si eucalipt. ",
    images: [aestheticBox],
  },
  {
    id: 250,
    name: "Beauty Box",
    price: "1600 lei",
    description:
      "Compoziție în cutie diametrul 20 cm, formată din trandafiri de tip Bujor, eustome, trandafiri avalanche și dianthus.",
    images: [beautyBox],
  },
  // {
  //   id: 257,
  //   name: "Elegance Box",
  //   price: "1800 lei",
  //   description:
  //     "Compoziție în cutie cu diametrul 22 cm formată din trandafiri de tip Bujor Sillva pink, hortesnsie si romanițe.",
  //   images: [eleganceBox],
  //   // checkAvailability: true,
  // },
  // {
  //   id: 258,
  //   name: "Summer",
  //   price: "1300 lei",
  //   description:
  //     "Cu diametrul 16 cm doar mată din hortensie, eustome, dianthus, gipsofila.",
  //   images: [summer],
  // },
  // {
  //   id: 259,
  //   name: "Timeless Beauty Box",
  //   price: "1500 lei",
  //   description:
  //     "Box cu diamentrul 16cm format din trandafiri, gherbere, crizanteme, dianthus, eustoma si eucalipt.",
  //   images: [timelessBeauty],
  // },
  {
    id: 261,
    name: "Elegant Bloom",
    price: "3300 lei",
    description:
      "Cos de marime XL format din trandafiri roz, astromerii albe si roz, antirinium si matiola.",
    images: [elegantBloom],
  },
  {
    id: 262,
    name: "Floral Symphony",
    price: "4100 lei",
    description:
      "Cos de marime XL format din trandafiri roz soi avalanche si eucalipt.",
    images: [floralSymphony],
    // checkAvailability: true,
  },
  {
    id: 263,
    name: "Pink Hydrangea",
    price: "1300 lei",
    description:
      "Cutie cu diamentru 16cm formata din hortensie roz, crizantema si trandafiri roz crenguta.",
    images: [pinkHydrangea],
  },
  {
    id: 264,
    name: "Orchid Box",
    price: "900 lei",
    description:
      "Cutie cu diamentru 12cm formata din orchidee roz, crizantema alba, antirinium si trandafiri roz crenguta.",
    images: [orchidBox],
    // checkAvailability: true,
  },
  // {
  //   id: 265,
  //   name: "Blue Hydrangea",
  //   price: "1200 lei",
  //   description:
  //     "Cutie cu diamentru 16cm formata din hortensie albastra, crizantema alba, dhiantus alb, eustoma alba, gipsofila alba si eucalipt.",
  //   images: [blueHydrangea],
  // },
];

export default compozitiiCutie;
